<template>
  <div class="filterOption">
    <ul class="outcatg_gallery_box1 option" id="topUsers">
      <li class="prod_gallry_col1" :class="getClass(1)">
        <input type="radio" id="under100" name="drone" value="under100" checked />
        <label for="under100" @click="selectFilterOption(0,100,1)">रु 100 के नीचे</label>
      </li>
      <li class="prod_gallry_col1" :class="getClass(2)">
        <input type="radio" id="100to300" name="drone" value="100to300" />
        <label for="100to300" @click="selectFilterOption(100,300,2)">रु 100 से रु 300</label>
      </li>

      <li class="prod_gallry_col1" :class="getClass(3)">
        <input type="radio" id="300t0500" name="drone" value="300t0500" />
        <label for="300t0500" @click="selectFilterOption(300,500,3)">रु 300 से रु 500</label>
      </li>

      <li class="prod_gallry_col1" :class="getClass(4)">
        <input type="radio" id="500to1000" name="drone" value="500to1000" />
        <label for="500to100" @click="selectFilterOption(500,1000,4)">रु 500 से रु 1000</label>
      </li>
      <li class="prod_gallry_col1" :class="getClass(5)">
        <input type="radio" id="1000to1000000" name="drone" value="1000to1000000" />
        <label for="1000to1000000" @click="selectFilterOption(1000,100000,5)">रु 1000 से ऊपर</label>
      </li>
    </ul>
    <div class="outcatg_gallery_box filter_option" v-if="salesProducts.length>0">
      <ul>
        <li v-for="(product,index) in salesProducts" :key="index">
          <div class="prod_gallry_col">
            <div
              v-lazyload
              class="image__wrapper"
              v-if="product.displayImage"
              @click="goToProductDetail(product.saleReferenceID)"
            >
              <ImageSpinner class="image__spinner" />
              <img class="image__item" :data-url="product.displayImage" :alt="product.productName" />
            </div>
            <div class="prod_short_detail">
              <div class="people_purchased">{{product.productName}}</div>
              <div class="off_price">
                <span class="greyTxt">
                  <strong>{{product.peopleBought}}</strong> लोगो ने ये सौदा ख़रीदा है
                </span>
              </div>
              <span
                class="shipping_txt"
                v-if="product.treatShipmentCostSeparate"
              >(₹​{{product.shipmentCost}} शिपिंग लागत अतिरिक्त)</span>
              <div class="discounted_price wdth100">
                <div
                    class="price_wrap wdth100 selectedAmtstatus"
                  >
                   

                    <span
                      class="disc_rate"
                    >Rs {{Number(product.groupPrice).toFixed(1)}}</span>
                     <span
                      class="old_rate"
                    >Rs {{Number(product.markedPrice).toFixed(1) }}</span>

                  </div>
                <!-- <div
                  :class="{'price_wrap wdth100 ':product.sellingPrice==product.markedPrice,'price_wrap wdth100 selectedAmtstatus':product.sellingPrice!=product.markedPrice}"
                >
                  <span
                    :class="{'disc_rate setRate': product.sellingPrice==product.markedPrice,'old_rate': product.sellingPrice!=product.markedPrice}"
                  >Rs {{Number(product.groupPrice).toFixed(1) }}</span>

                  <span
                    class="disc_rate"
                    v-if="product.sellingPrice!=product.markedPrice"
                  >Rs {{Number(product.sellingPrice).toFixed(1)}}</span>

                  <span
                    v-else
                    class="disc_rate priceBtn"
                    @click="getUserPrice(product.saleReferenceID,product)"
                  >मेरी कीमत</span>
                </div> -->
              </div>
            </div>
          </div>
        </li>
      </ul>
      <infinite-loading @infinite="infiniteHandler" spinner="circles">
        <template slot="no-more">और रिकॉर्ड उपलब्ध नहीं है</template>
      </infinite-loading>
    </div>
    <div class="cntntLoad" v-if="cntntLoad">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
    <div class="cntntLoad" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import constant from "../../utils/constant";
import { bus } from "../../main";
import ImageSpinner from "../Common/ImageSpinner";

export default {
  name: "FilterOption",
  components: {
    ImageSpinner
  },

  data() {
    return {
      offsetValue: 10186,
      salesProducts: [],
      busy: false,
      pageIndex: 0,
      page: 1,
      isActive: false,
      min: 0,
      max: 100,
      selectedFilterType: 1,
      cntntLoad: false,
      loading: false,
      filterStateStatus: false
    };
  },
  methods: {
    getUserPrice(saleReferenceID, productDto) {
      this.cntntLoad = true;
      this.$store
        .dispatch({
          type: "getUserPriceProduct",
          payload: saleReferenceID
        })
        .then(data => {
          productDto.sellingPrice = data.data.totalPaidAmount;
          this.cntntLoad = false;
        })
        .catch(err => {
          this.cntntLoad = false;
          productDto.sellingPrice = productDto.groupPrice;
          // let obj = {
          //   status: "Failure",
          //   timeoutMs: "5000"
          // };
          // bus.$emit("apiStatus", obj);
          console.log(err);
        });
    },
    getOffset() {
      const testDiv = document.querySelector(".filterOption");
      this.offsetValue = testDiv.offsetTop;
    },
    getClass(type) {
      if (this.selectedFilterType == type) {
        return "active";
      }
    },

    selectFilterOption(min, max, type) {
      if (parseInt(this.selectedFilterType) === parseInt(type)) {
        this.isActive = true;
        this.loading = false;
        return;
      }
      this.filterStateStatus = true;
      this.loading = true;
      this.selectedFilterType = type;
      this.min = min;
      this.max = max;
      this.pageIndex = 0;
      this.salesProducts = [];
      this.infiniteHandler();
    },

    infiniteHandler($state) {
      if (this.$data.pageIndex != -1 && !this.cntntLoad) {
        const obj = {
          pageIndex: this.pageIndex,
          saleType: "DISCOUNT",
          minPrice: this.min,
          maxPrice: this.max
        };

        if (this.pageIndex == 1) {
          this.getOffset();
        }
        this.$store
          .dispatch({
            type: "getSalesListing",
            payload: obj
          })
          .then(({ data }) => {
            if (this.pageIndex == 0) {
              this.salesProducts = [];
            }
            if (data.saleProductDTOs.length > 0) {
              this.salesProducts = this.salesProducts.concat(
                data.saleProductDTOs
              );
              this.$store.commit("saveDiscountedProduct", {
                salesDiscountedProducts: this.salesProducts,
                pageIndex: this.$data.pageIndex,
                selectedFilterType: this.$data.selectedFilterType
              });

              this.$data.pageIndex = this.$data.pageIndex + 1;
              this.cntntLoad = false;
              this.loading = false;
              this.filterStateStatus = false;
              $state && $state.loaded();
            } else {
              this.$data.pageIndex = -1;
              this.loading = false;
              this.cntntLoad = false;
              $state && $state.complete();
            }
          })
          .catch(err => {
            console.log(err)
            // let obj = {
            //   status: "Failure",
            //   timeoutMs: "5000"
            // };
            // bus.$emit("apiStatus", obj);
          });
      }
    },
    goToProductDetail(productSrId) {
      this.$router.onError(err => {
        if (/loading chunk \d* failed./i.test(err.message)) {
           window.location.reload()
        }
      });
      this.$router.push("/detail/" + productSrId);
    }
  },

  mounted() {
    if (
      this.$store.getters.salesDiscountedProducts &&
      this.$store.getters.salesDiscountedProducts.length > 0
    ) {
      this.salesProducts = this.$store.getters.salesDiscountedProducts;
      (this.$data.pageIndex = this.$store.getters.pageIndex + 1),
        (this.selectedFilterType = this.$store.getters.selectedFilterType);
      if (this.selectedFilterType == 1) {
        this.min = 0;
        this.max = 100;
      } else if (this.selectedFilterType == 2) {
        this.min = 100;
        this.max = 300;
      } else if (this.selectedFilterType == 3) {
        this.min = 300;
        this.max = 500;
      } else if (this.selectedFilterType == 4) {
        this.min = 500;
        this.max = 1000;
      } else if (this.selectedFilterType == 5) {
        this.min = 1000;
        this.max = 100000;
      }
    } else {
      this.infiniteHandler();
    }

    let topUsers = document.querySelector("#topUsers");
    let mainScreen = document.querySelector(".main_section");
    var _this = this;
    try {
      mainScreen.addEventListener("scroll", function(e) {
        if (mainScreen.scrollTop >= _this.offsetValue) {
          topUsers.classList.add("expanded");
        } else {
          topUsers.classList.remove("expanded");
        }
      });
    } catch (err) {
      console.log(err);
    }
  }
};
</script>